import { useCallback } from 'react';

import useRequestJSON from './hooks/useRequestJSON';
import { PostJSON, BaseResponse } from './request';
import { ICustomProgram } from './composer';

export interface GetRoutesParams {
  keys: string[];
  patientId: number;
  customPrograms?: ICustomProgram[];
}

export interface RouteMapping {
  call: string;
  message: string;
}

export type RouteMappings = Record<string, RouteMapping>;

export interface GetRoutesResponse extends BaseResponse {
  mappings: RouteMappings;
}

export const useGetRoutes = (
  params: GetRoutesParams
): { routes: RouteMappings } => {
  const request = useCallback(
    () =>
      PostJSON({
        url: '/route/data/',
        params
      }),
    [JSON.stringify(params.keys), params.patientId]
  );
  const { data } = useRequestJSON<GetRoutesResponse>({
    request,
    enabled: params.keys?.length > 0 && params.patientId != null
  });
  return {
    routes: data?.mappings || {}
  };
};
